export type OverviewShownLevel = number | null;

export function getOverviewLevelKey(level: OverviewShownLevel): string {
  if (level === null) {
    return 'null';
  }
  return `${level}`;
}

export function isAdminOverviewLevel(level: OverviewShownLevel): level is number {
  return typeof level === 'number';
}
